// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  playerId: __t.string().primaryKey().name("player_id"),
  lobbyId: __t.string().name("lobby_id"),
  team: __t.u32(),
  playerName: __t.string().name("player_name"),
  generalArchetype: __t.string().name("general_archetype"),
  unitArchetypes: __t.string().name("unit_archetypes"),
  joinedAt: __t.timestamp().name("joined_at"),
});
